import { pathOr } from 'ramda';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useMapZoom } from './useMapZoom';
import { IPinsLayer } from './usePinsLayer';
import { IFeaturesMap } from '../../../../common/types/map';
import { IApplicationState } from '../../../../common/types/redux';
import { selectMapBounds } from '../../../selectors';
import { TMapBounds } from '../../../types/mapBounds';

interface IUsePinsTestModeParams extends IPinsLayer {
  map: YMaps.Map;
}

export function usePinsTestMode({ map, rbush }: IUsePinsTestModeParams): void {
  const { bounds, precision } = useSelector<IApplicationState, TMapBounds>(selectMapBounds);
  const zoom = useMapZoom(map);
  const features = useSelector<IApplicationState, IFeaturesMap>(state =>
    pathOr<IFeaturesMap>({}, [precision, 'features'], state.map.features),
  );

  window._cianService = window._cianService || {};
  window._cianService['dailyrent-search-frontend'] = window._cianService['dailyrent-search-frontend'] || {};
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  window._cianService!['dailyrent-search-frontend'].getPoints = React.useCallback(() => {
    if (!bounds) {
      return null;
    }

    const mapProjection: YMaps.projection.wgs84Mercator = map.options.get('projection');

    const [mapPixelCoordX, mapPixelCoordY] = mapProjection.toGlobalPixels([bounds[0][0], bounds[0][1]], zoom);

    const featuresInBbox = rbush.search({
      minX: bounds[0][0],
      minY: bounds[0][1],
      maxX: bounds[1][0],
      maxY: bounds[1][1],
    });

    return featuresInBbox.map(feature => {
      const [featureCoordX, featureCoordY] = feature.feature.geometry.coordinates;

      const [featurePixelCoordX, featurePixelCoordY] = mapProjection.toGlobalPixels(
        [featureCoordX, featureCoordY],
        zoom,
      );

      return {
        feature: feature.feature,
        position: [Math.round(featurePixelCoordX - mapPixelCoordX), Math.floor(mapPixelCoordY - featurePixelCoordY)],
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bounds, features, map, rbush, zoom]);
}
